import React, { useState } from 'react';
import BaseSidebarPanel from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/BaseSidebarPanel';
import BooleanInput from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/inputs/BooleanInput';
import TextInput from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/inputs/TextInput';
import MultiStylePropertyPanel from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/style-inputs/MultiStylePropertyPanel';
import TextBlock from './index';
export default function TextSidebarPanel({ data, setData }) {
    var _e, _t, _y, _10;
    const [, setErrors] = useState(null);
    const updateData = (d) => {
        const res = TextBlock.schema.safeParse(d);
        if (res.success == true) {
            setData(res.data);
            setErrors(null);
        }
        else {
            setErrors(res.error);
        }
    };
    return (React.createElement(BaseSidebarPanel, { title: "Text block" },
        React.createElement(TextInput, { label: "Content", rows: 5, defaultValue: (_t = (_e = data.props) === null || _e === void 0 ? void 0 : _e.text) !== null && _t !== void 0 ? _t : '', onChange: (text) => updateData(Object.assign(Object.assign({}, data), { props: Object.assign(Object.assign({}, data.props), { text }) })) }),
        React.createElement(BooleanInput, { label: "Markdown", defaultValue: (_10 = (_y = data.props) === null || _y === void 0 ? void 0 : _y.markdown) !== null && _10 !== void 0 ? _10 : false, onChange: (markdown) => updateData(Object.assign(Object.assign({}, data), { props: Object.assign(Object.assign({}, data.props), { markdown }) })) }),
        React.createElement(MultiStylePropertyPanel, { names: ['color', 'backgroundColor', 'fontFamily', 'fontSize', 'fontWeight', 'textAlign', 'padding'], value: data.style, onChange: (style) => updateData(Object.assign(Object.assign({}, data), { style })) })));
}
//# sourceMappingURL=TextSidebarPanel.js.map